<div class="searchbar-top gap-2">
  <div class="input-group m-0">
    <input type="text" class="form-control" [(ngModel)]="enterSearch" placeholder="Search...." aria-label="Search"
      aria-describedby="search-addon" (keyup)="search($event)" oninput="this.value = this.value.replace(/^\s+/g, '')" />
    <span class="input-group-text border-0" id="search-addon">
      <i class="fas fa-search"></i>
    </span>
    <span type="button" class="input-group-append" (click)="cancelSearch()" *ngIf="searchClose">
      <i class="fas fa-times"></i>
    </span>
  </div>
  <button type="button" class="btn btn-primary common-button m-0" title="Add Exam" (click)="Add()"><i
      class="fas fa-plus pe-2"></i><span>{{TestConstant.ADD_TEST}}</span></button>
</div>
<div class="card-content">
  <div class="row table-touch">
    <div class="col-sm-12">
      <div class="mat-custom-table">
        <div class="table-responsive">
          <table mat-table matSort [dataSource]="dataSource" (matSortChange)="SortChange($event)"
            aria-describedby="list">
            <ng-container matColumnDef="rowNumber">
              <th mat-header-cell *matHeaderCellDef>{{CommonConstant.SR}} </th>
              <td mat-cell *matCellDef="let element"> {{element.rowNumber}} </td>
            </ng-container>
            <ng-container matColumnDef="examName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{TestConstant.NameOfTest}}
              </th>
              <td mat-cell *matCellDef="let element" title="{{element.examName}}" class="wrapper"> <span
                  class="paraWrap"> {{element.examName}} </span> </td>
            </ng-container>
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef> {{TestConstant.Date}} </th>
              <td mat-cell *matCellDef="let element"> {{element.examDate | date: 'dd/MM/yyyy'}} </td>
            </ng-container>
            <ng-container matColumnDef="examTime">
              <th mat-header-cell *matHeaderCellDef>{{TestConstant.TestTime}}</th>
              <td mat-cell *matCellDef="let element"> {{element.startTime | date: 'hh:mm a' }} To {{element.endTime |
                date: 'hh:mm a' }}</td>
            </ng-container>
            <ng-container matColumnDef="durationInMins">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{TestConstant.TestDuration}}</th>
              <td mat-cell *matCellDef="let element"> {{ timeConvert(element.durationInMins)}} </td>
            </ng-container>
            <ng-container matColumnDef="noOfStudent">
              <th mat-header-cell *matHeaderCellDef> {{TestConstant.NumberofStudent}}
              </th>
              <td mat-cell *matCellDef="let element"> {{element.noOfStudent}} </td>
            </ng-container>
            <ng-container matColumnDef="attemptedStudent">
              <th mat-header-cell *matHeaderCellDef > {{TestConstant.AttemptedStudent}}
              </th>
              <td mat-cell *matCellDef="let element"> {{element.attemptedStudent}}</td>
            </ng-container>

            <ng-container matColumnDef="Live/Result">
              <th mat-header-cell *matHeaderCellDef> {{TestConstant.LiveResult}} </th>
              <td mat-cell *matCellDef="let element">
                <div class="action-button-group livetestswitch">
                  <label class="switch">
                    <input type="checkbox"  class="switch-input isLiveCheckBox" [checked]="!element.isLive"
                      (change)="liveTest(element.examId,element.examName,element.isLive,getDate(element.endTime),$event)">
                    <span class="switch-label" data-on="Live" data-off="On Hold"></span>
                    <span class="switch-handle"></span>
                  </label>
                  <a class="detailicon eyeresult" title="View Result" (click)="viewResult(element.examId,element)">
                    <i class="fa fa-eye"></i><span>Result</span>
                  </a>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="Action">
              <th mat-header-cell *matHeaderCellDef> {{CommonConstant.ACTION}} </th>
              <td mat-cell *matCellDef="let element">
                <div class="action-button-group">
                  <a class="detailicon" title="Exam Details" (click)="TestDetail(element.examId)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" class="bi bi-info-lg"
                      viewBox="0 0 16 16">
                      <path
                        d="m9.708 6.075-3.024.379-.108.502.595.108c.387.093.464.232.38.619l-.975 4.577c-.255 1.183.14 1.74 1.067 1.74.72 0 1.554-.332 1.933-.789l.116-.549c-.263.232-.65.325-.905.325-.363 0-.494-.255-.402-.704l1.323-6.208Zm.091-2.755a1.32 1.32 0 1 1-2.64 0 1.32 1.32 0 0 1 2.64 0Z" />
                    </svg></a>
                  <a class="editicon" title="Exam Edit" *ngIf="getDate(element.startTime)> currentDateTime"
                    (click)="RedirectToEdit(element.examId)"><svg xmlns="http://www.w3.org/2000/svg" width="12"
                      height="12" fill="#003B61" class="bi bi-pencil-fill" viewBox="0 0 16 16">
                      <path
                        d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                    </svg></a>
                  <a class="deleteicon" title="Exam Delete" *ngIf="getDate(element.startTime) > currentDateTime"
                    (click)="Deletepopup(element.examId,element.examName)"><i class="fa fa-trash"></i></a>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div *ngIf="showData" [ngClass]="dataSource.filteredData.length > 0 ? 'hidden' : 'visible'">
            <h5 class="text-center no-data-available py-4">{{NoRecordFound.NoExamFound}}</h5>
          </div>
        </div>
        <mat-paginator #paginator [length]="totalRows" [pageIndex]="currentPage" showFirstLastButtons
          [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageChanged($event)"
          aria-label="Select page">
        </mat-paginator>
      </div>
    </div>
  </div>
</div>